/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.FeatureCategoriesRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getCategoriesByApiNamesRpc = {
  serviceName: 'com.hubspot.feature.store.rpc.FeatureCategoriesRpc',
  rpcName: 'getCategoriesByApiNames',
  auth: 'external',
  fingerprint: 'srjov8SXFcdpyBOb2hG0BpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};